import { fetchCsrf, fetchHttp } from './useRequest';

export const getOnlineGiving = async (slug: string): Promise<Response> => {
    await fetchCsrf();

    return fetchHttp(`/api/online-giving/${slug}`, { method: 'get' });
};

export const register = async (
    payload: Record<string, unknown>
): Promise<Response> => {
    await fetchCsrf();

    return fetchHttp('/api/give/register', {
        method: 'post',
        body: JSON.stringify(payload)
    });
};

export const createGivingSetupIntent = async (organizationPrefixedId: string | undefined, stripeCustomerId: string): Promise<Response> => {
    await fetchCsrf();

    /* eslint-disable camelcase */
    return fetchHttp('/api/give/setup-intent', {
        method: 'post',
        body: JSON.stringify({
            organization_prefixed_id: organizationPrefixedId,
            stripe_customer_id: stripeCustomerId
        })
    });
    /* eslint-enable camelcase */
};

export const onlineGivingRegisterCustomer = async (payload: Record<string, unknown>): Promise<Response> => {
    await fetchCsrf();
    return fetchHttp('/api/give/customer', {
        method: 'post',
        body: JSON.stringify(payload)
    });
};

export const getStripeCustomerPaymentMethods = async (payload: Record<string, unknown>): Promise<Response> => {
    await fetchCsrf();

    return fetchHttp(
        `/api/give/stripe-payment-methods?stripe_customer_id=${payload.stripe_customer_id}&organization_prefixed_id=${payload.organization_prefixed_id}`,
        { method: 'GET' }
    );
};

export const getDonorStripeCustomerId = async (payload: Record<string, unknown>): Promise<Response> => {
    await fetchCsrf();

    return fetchHttp(
        `/api/give/stripe-customer-id?donor_prefixed_id=${payload.donor_prefixed_id}&organization_prefixed_id=${payload.organization_prefixed_id}`,
        { method: 'GET' }
    );
};

export const onlineGivingPayment = async (payload: Record<string, unknown>): Promise<Response> => {
    await fetchCsrf();

    return fetchHttp('/api/give', {
        method: 'post',
        body: JSON.stringify(payload)
    });
};
